"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureUnit = void 0;
var type_guard_1 = require("@webnuts/type-guard");
exports.measureUnit = type_guard_1.pattern(/^(?:^-?\d+(\.\d+)?(cm|mm|in|pc|pt|px|em|ex|ch|rem|lh|vw|vh|vi|vb|fr|vmin|vmax|%)|auto|unset|inherit|fit-content|min-content|max-content|0|calc\(.*?\))$/);
